<template lang="pug">
  .tuple-container
    .search
    .list-wrapper
      .head
        .head-left 币对
        //- .head-right 涨幅
      ul(class="list")
        li(v-for="item in list" 
           :class="item.selected ? 'active' : null"
           @click="handleChangeTuple(item)")
          .instrumentId {{item.instrumentId.toUpperCase()}}
          //- .change(:class="item.change>=0 ? 'green' : 'red'") \
          //- {{`${item.change>=0 ? '+' : ''}${item.change}%`}}
</template>

<script>
import { getTupleList } from 'api/trade';
import * as R from 'ramda';

export default {
  props: {},
  data() {
    return {
      currency: 'USDT',
      iptVal: '',
      list: [],
    };
  },
  computed: {
    renderList() {
      return this.list.filter((item) => item.instrumentId.indexOf(this.iptVal) !== -1);
    },
  },
  watch: {
    $route(to) {
      const oldCurrency = this.currency;
      const newCurrency = to.params.tuple.toUpperCase().split('-')[1];
      this.currency = newCurrency;
      if (newCurrency !== oldCurrency) {
        this.queryList();
      }
    },
  },
  created() {},
  mounted() {
    this.currency = this.$route.params.tuple.toUpperCase().split('-')[1];
    this.queryList();
  },
  methods: {
    queryList() {
      getTupleList({ quoteCurrency: this.currency })
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.list = res.data.currencyList;
            this.list = R.map(R.assoc('selected', false))(this.list);
            this.list.forEach((item) => {
              if (item.instrumentId.toLowerCase() === this.$route.params.tuple) {
                item.selected = true;
              }
            });
          } else {
            this.$message.error('获取到币对失败');
          }
        })
        .catch(() => this.$message.error('获取币对列表发生错误'));
    },
    handleChangeTuple(selected) {
      if (selected.selected) return;
      const chkSele = R.ifElse(
        R.eqProps('instrumentId', selected),
        R.assoc('selected', true),
        R.assoc('selected', false),
      );
      this.list = R.map(chkSele)(this.list);
      this.$router.replace(`/trade/${selected.instrumentId.toLowerCase()}`);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../styles/consts.less';

.tuple-container {
  display: block;
  font-size: 14px;
  width: 100%;
  .search {
  }
  .list-wrapper {
    border: none;
    border-radius: 0 0 4px 4px;
    padding-bottom: 10px;
    padding-top: 1px;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 200px;
      height: 26px;
      font-size: 12px;
      .head-left {
        padding-left: 28px;
        height: 18px;
        line-height: 18px;
      }
      .head-right {
        padding-right: 12px;
      }
    }
    .list {
      height: 324px;
      overflow: auto;
      li {
        font-size: 14px;
        position: relative;
        display: flex;
        align-items: center;
        height: 36px;
        line-height: 36px;
        padding: 0 8px;
        cursor: pointer;
        user-select: none;
        .instrumentId {
          height: 21px;
          line-height: 21px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .change {
          position: absolute;
          font-size: 12px;
          right: 8px;
        }
        .green {
          color: #2ead65;
        }
        .red {
          color: #e35e5e;
        }
      }
      .active {
        background: rgba(64, 158, 255, 0.05);
        box-shadow: inset 3px 0 0 0 @themeColor;
      }
    }
  }
}
</style>
